function sendNotification(type, text) {
  let notificationBox = document.querySelector(".notification-box");
  const alerts = {
    info: {
      icon: `<svg height="24" width="24" class="mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>`,
      color: "info",
    },
    error: {
      icon: `<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" class="mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>`,
      color: "danger",
    },
    warning: {
      icon: `<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" class="mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
  </svg>`,
      color: "warning",
    },
    success: {
      icon: `<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" class="mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>`,
      color: "success",
    },
  };
  let component = document.createElement("div");
  component.className = `position-relative w-100 d-flex align-items-center bg-${alerts[type].color} text-white fs-6 fw-bold px-4 py-3 rounded opacity-0 mb-1`;
  component.style = "transition: all 0.5s;";
  component.innerHTML = `${alerts[type].icon}<div style="margin-left: 5px;">${text}</div>`;
  notificationBox.appendChild(component);
  setTimeout(() => {
    component.classList.remove("opacity-0");
    component.classList.add("opacity-1");
  }, 1); //1ms For fixing opacity on new element
  setTimeout(() => {
    component.classList.remove("opacity-1");
    component.classList.add("opacity-0");
    //component.classList.add("-translate-y-80"); //it's a little bit buggy when send multiple alerts
    component.style.margin = 0;
    component.style.padding = 0;
  }, 5000);
  setTimeout(() => {
    // component.style.setProperty("border-radius", "20px", "important");
    component.style.setProperty("height", "0", "important");
  }, 5100);
  setTimeout(() => {
    notificationBox.removeChild(component);
  }, 5700);
  //If you can do something more elegant than timeouts, please do, but i can't
}

{
  // methods
  //   <section class="flex flex-col-reverse min-h-screen">
  //   <div class="panel flex flex-wrap mx-auto gap-2 pb-3">
  //     <button onClick="sendNotification('info', 'New info alert!')" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded self-bottom">
  //       Click me
  //     </button>
  //     <button onClick="sendNotification('error', 'New error alert!')" class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded self-bottom">
  //       And me
  //     </button>
  //     <button onClick="sendNotification('warning', 'New warning alert!')" class="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded self-bottom">
  //       Me too
  //     </button>
  //     <button onClick="sendNotification('success', 'New success alert!')" class="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded self-bottom">
  //       I'm here!
  //     </button>
  //   </div>
  // </section>
}

export default sendNotification;
